import { Injectable, OnDestroy, Pipe, PipeTransform, signal, untracked } from '@angular/core';
import { DateUtility } from "@utilities/date.utility";

@Pipe({
	name: 'DateAgo',
	standalone: true,
	pure: false,
})
@Injectable({
	providedIn: 'root',
})
export class DateAgoPipe implements PipeTransform, OnDestroy {
	private prevValue: string | null = null;
	private prevFormat: 'short' | 'long' = 'long';
	private state = signal<string | null>(null);
	private intervalId: any;

	constructor(private dateUtility: DateUtility) {}

	private startTimer(value: string, format: 'short' | 'long'): void {
		this.intervalId = setInterval(() => {
			this.state.set(this.dateUtility.relative(value, format));
		}, 1000);
	}

	transform(value: string, format: 'short' | 'long' = 'long'): string | null {
		if (!value || typeof value !== 'string') {
			if (this.intervalId) {
				clearInterval(this.intervalId);
				this.intervalId = null;
			}
			return null;
		}

		if (this.prevValue !== value || this.prevFormat !== format) {
			this.prevValue = value;
			this.prevFormat = format;

			if (this.intervalId) {
				clearInterval(this.intervalId);
			}

			this.state = untracked(() => {
				const newState = signal<string | null>(this.dateUtility.relative(value, format));
				return newState;
			});

			this.startTimer(value, format);
		}

		return this.state();
	}


	ngOnDestroy(): void {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}
}
